// extracted by mini-css-extract-plugin
export default {"container":"PieChart_container__+-p1B","noData":"PieChart_noData__rhan9","chartBadge":"PieChart_chartBadge__ugO5f","loaderWrapper":"PieChart_loaderWrapper__JSknU"};